import { createSelector } from "reselect";
import { initialState } from "./reducer";
import { compareString } from "helpers/generalUtils";

const reducerState = (state) => state.ProductUnit || initialState;

const makeProductUnitSelectField = (field) =>
  createSelector(reducerState, (productUnitState) => productUnitState[field]);

const selectSortedProductUnitType = () =>
  createSelector(
    makeProductUnitSelectField("productUnitTypeList"),
    (productUnit) =>
      productUnit
        .map((opt) => ({
          value: opt.unitTypeId,
          label: opt.unitTypeName,
        }))
        .sort((item1, item2) => compareString(item1.label, item2.label))
  );

export {
  reducerState,
  makeProductUnitSelectField,
  selectSortedProductUnitType,
};
